import { Instagram, Youtube, Twitter, Linkedin, Globe, Music2 } from "lucide-react";

export const SOCIALS = [
  { key: "instagram", label: "Instagram", icon: Instagram, base: "https://instagram.com/", tint: "hover:bg-pink-100 hover:text-pink-600", ph: "@handle" },
  { key: "tiktok", label: "TikTok", icon: Music2, base: "https://tiktok.com/@", tint: "hover:bg-slate-900 hover:text-white", ph: "@handle" },
  { key: "youtube", label: "YouTube", icon: Youtube, base: "https://youtube.com/@", tint: "hover:bg-red-100 hover:text-red-600", ph: "@channel" },
  { key: "twitter", label: "X / Twitter", icon: Twitter, base: "https://x.com/", tint: "hover:bg-sky-100 hover:text-sky-600", ph: "@handle" },
  { key: "linkedin", label: "LinkedIn", icon: Linkedin, base: "https://linkedin.com/in/", tint: "hover:bg-blue-100 hover:text-blue-700", ph: "username" },
  { key: "website", label: "Website", icon: Globe, base: "", tint: "hover:bg-fuchsia-100 hover:text-fuchsia-600", ph: "https://yoursite.com" },
];

export function socialHref(key, val) {
  const v = (val || "").trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return v;
  const s = SOCIALS.find((x) => x.key === key);
  if (!s) return null;
  if (key === "website") return `https://${v}`;
  return s.base + v.replace(/^@/, "");
}

export function hasSocials(socials) {
  return socials && Object.values(socials).some(Boolean);
}
